import { CheckCircleIcon, Squares2X2Icon, XCircleIcon } from '@heroicons/react/24/outline';

import { Button } from '@/components/core/Button';
import { Icon } from '@/components/core/Icon';
import { ToggleGroup, ToggleGroupItem } from '@/components/core/ToggleGroup';
import { FacetedFilter, FacetedFilterOption } from '@/components/FacetedFilter';
import { FacetedFilterActionDispatcher } from '@/components/FacetedFilter/FacetedFilter';
import { useTranslation } from '@/hooks/useTranslation';

import { ReactComponent as Squares3x3Icon} from '../../../assets/icons/squares3x3.svg';
import { GalleryMode } from '../export-media-asset.types';

interface ToolbarProps {
    attributeFilterOptions: FacetedFilterOption[];
    selectedAttributeFilters: FacetedFilterOption[];
    attributeFilterDispatch: FacetedFilterActionDispatcher;
    areAllSelected: boolean;
    onSelectAll: () => void;
    isShowingOnlySelected: boolean;
    onShowSelected: () => void;
    galleryMode: GalleryMode;
    onGalleryModeChanged: (mode: GalleryMode) => void;
}

const Toolbar = ({ areAllSelected, isShowingOnlySelected, attributeFilterOptions,
    selectedAttributeFilters, attributeFilterDispatch, onSelectAll, onShowSelected, galleryMode, onGalleryModeChanged }: ToolbarProps) => {

    const { t } = useTranslation();

    return (
        <div className="tw-flex tw-flex-row tw-py-3 tw-px-6 tw-border-b-2 tw-border-solid tw-border-[--light-gray] tw-border-l-0 tw-border-r-0 tw-border-t-0">
            <FacetedFilter
                title={t('MEDIA_ASSET_EXPORT.FILTER')}
                options={attributeFilterOptions}
                selectedOptions={selectedAttributeFilters}
                dispatch={attributeFilterDispatch}
            />

            <Button  variant="outline"
                onClick={onSelectAll}
                className="tw-ml-1"
            >
                <span className="tw-mr-1">
                    <Icon
                        icon={areAllSelected ? XCircleIcon : CheckCircleIcon}
                        size="sm"
                        variant="secondary"
                    />
                </span>
                <span className="tw-inline-flex">
                    {areAllSelected
                        ? t('MEDIA_ASSET_EXPORT.DESELECT_ALL')
                        : t('MEDIA_ASSET_EXPORT.SELECT_ALL')}
                </span>
            </Button>

            <Button variant="outline" onClick={onShowSelected} className="tw-ml-1">
                {isShowingOnlySelected ? t('MEDIA_ASSET_EXPORT.SHOW_ALL') : t('MEDIA_ASSET_EXPORT.SHOW_SELECTED')}
            </Button>

            <div className="tw-ml-auto">
                <ToggleGroup
                    type="single"
                    aria-label=""
                    className="tw-flex tw-items-center"
                    value={galleryMode}
                    onValueChange={(value: GalleryMode) => {
                        if (value) onGalleryModeChanged(value);
                    }}
                >
                    <ToggleGroupItem variant="icon" value="large" aria-label="Large" className="tw-flex tw-items-center jtw-ustify-center">
                        <Icon icon={Squares2X2Icon} variant="dark" size="md" />
                    </ToggleGroupItem>
                    <ToggleGroupItem variant="icon" value="small" aria-label="Left aligned" className="tw-flex tw-items-center jtw-ustify-center">
                        <Icon icon={Squares3x3Icon}   variant="dark" size="md"/>
                    </ToggleGroupItem>
                </ToggleGroup>
            </div>
        </div>
    );
};

export { Toolbar };
